import { T } from '@transifex/react';
import { Text } from '@vidahealth/vida-ui';
import { LinearGradient } from 'expo-linear-gradient';
import { View } from 'react-native';

/** Gradient "Best fit" pill marking the recommended coach. */
export function BestFitPill() {
  return (
    <View className='w-fit'>
      <LinearGradient
        colors={['#65A4E2', '#066ACF', '#0554A3']}
        locations={[0, 0.255, 0.85]}
        start={{ x: 1, y: 0.4 }}
        end={{ x: 0, y: 0.6 }}
        style={{ paddingHorizontal: 12, paddingVertical: 6, borderRadius: 18 }}
      >
        <Text className='text-primary-0' size='sm' weight='medium'>
          <T _str='Best fit' />
        </Text>
      </LinearGradient>
    </View>
  );
}
